import { from } from 'rxjs';
import { filter } from 'rxjs/operators';
import { BROADCAST_START_PROGRAM } from '@shoflo/studio-redux/actions/program/types';

/**
 * This middleware is used to update the background image sigend url in program inside the state.
 * @returns
 */
function updateBackgroundOnProgramStartMiddleware() {
  return store => next => async action => {
    const targetActions = [BROADCAST_START_PROGRAM];
    from([action])
      .pipe(filter($action => targetActions.includes($action.type)))
      .subscribe($action => {
        if (targetActions.includes($action.type)) {
          const { program, backgrounds } = store.getState();

          backgrounds.map(background => {
            if (program?.style?.backgroundId === background._id) {
              program.style.backgroundImage = `url(${background.source.value.url})`;
            }
          });
        }
      });

    return next(action);
  };
}

export default updateBackgroundOnProgramStartMiddleware;
